import React from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_PHONE } from "../config";
import { trackEvent } from "../lib/analytics";

const Home = () => {
  return (
    <>
      <div className="hero border-1 pb-3">
        <div className="card bg-dark text-white border-0 mx-3 hero-card">
          <img
            className="card-img img-fluid hero-img"
            src="./assets/main.png.jpg"
            alt="Card"
          />
          <div className="card-img-overlay d-flex align-items-center">
            <div className="container">
              <p className="text-uppercase fw-semibold mb-2" data-aos="fade-up">
                A1 Pro
              </p>
              <h5
                className="card-title display-4 fw-semibold"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Cursos tecnicos premium
              </h5>
              <p
                className="card-text fs-5 d-none d-sm-block"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Ingenieria civil, automatizacion y diseno digital.
              </p>
              <div
                className="d-flex flex-wrap gap-2 mt-4"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <Link to="/product" className="btn btn-light btn-lg">
                  Ver cursos
                </Link>
                <a
                  href={`https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=Hola,%20quiero%20informaci%C3%B3n%20de%20A1%20Pro`}
                  className="btn btn-whatsapp btn-lg"
                  onClick={() => trackEvent("whatsapp_click", { source: "hero_cta" })}
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
